/* unplugin-vue-components disabled */import { render } from "./goalsUnlock.vue?vue&type=template&id=0af1110f&scoped=true"
import script from "./goalsUnlock.vue?vue&type=script&lang=js"
export * from "./goalsUnlock.vue?vue&type=script&lang=js"

import "./goalsUnlock.vue?vue&type=style&index=0&id=0af1110f&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0af1110f"]])

export default __exports__